import { Flex, FlexProps } from '@chakra-ui/react'
import { Session } from 'next-auth'
import { FC, ReactNode, createContext, useContext } from 'react'

import { NavigationBar, NavigationBarProps } from '@components/Navigation'
import { Footer } from '@components/marketing/Footer'

const LayoutContext = createContext<{
  isFooterVisible: boolean
}>({
  isFooterVisible: false,
})

export const useLayoutContext = () => useContext(LayoutContext)

export type LayoutProps = {
  children?: ReactNode
  onSignIn?: () => void
  onSignOut?: () => void
  session?: null | Session
  blendNavigation?: NavigationBarProps['blend']
  minimalFooter?: boolean
  hideFooter?: boolean
  hideMenu?: boolean
  hideNav?: boolean
  layerStyle?: FlexProps['layerStyle']
}

export const Layout: FC<LayoutProps> = ({
  children,
  onSignIn,
  onSignOut,
  session,
  blendNavigation,
  layerStyle = 'softerWhite',
  minimalFooter,
  hideFooter,
  hideNav,
  hideMenu,
}) => {
  return (
    <Flex
      direction="column"
      alignItems="stretch"
      bg="tertiary"
      position="relative"
      width="100%"
      minHeight="100vh"
    >
      {!hideNav && (
        <NavigationBar
          onSignIn={onSignIn}
          onSignOut={onSignOut}
          user={session?.user}
          blend={blendNavigation}
          hideMenu={hideMenu}
        />
      )}
      <Flex flexDirection="column" layerStyle={layerStyle} flex={1}>
        {children}
      </Flex>
      {hideFooter ? null : <Footer minimal={minimalFooter} />}
    </Flex>
  )
}

export type ScreenProps = FlexProps

export const Screen: FC<ScreenProps> = (props) => (
  <Flex
    maxWidth="container.xl"
    width="100%"
    alignItems="center"
    alignSelf="center"
    direction="column"
    py={['md', 'xxxl']}
    {...props}
  />
)

export const WideScreen: FC<ScreenProps> = (props) => (
  <Flex
    maxWidth="container.xl"
    width="100%"
    alignItems="center"
    alignSelf="center"
    direction="column"
    py={['md', 'xxxl']}
    {...props}
  />
)
